import { gql } from '@apollo/client';

const SUGGESTION_FIELDS = `
  id
  submitted_url
  platform
  title
  use_case
  note
  thumbnail_url
  author_name
  status
  vote_count
  submitted_by_name
  brand_kit_id
  promoted_at
  createdAt
`;

export const TEMPLATE_SUGGESTIONS = gql`
  query TemplateSuggestions($status: String, $sort: String, $limit: Int, $offset: Int) {
    templateSuggestions(status: $status, sort: $sort, limit: $limit, offset: $offset) {
      data { ${SUGGESTION_FIELDS} viewer_has_voted }
      total
      pageCount
    }
  }
`;

export const MY_TEMPLATE_SUGGESTIONS = gql`
  query MyTemplateSuggestions {
    myTemplateSuggestions { ${SUGGESTION_FIELDS} review_reason reviewed_at }
  }
`;

export const CREATE_MY_TEMPLATE_SUGGESTION = gql`
  mutation CreateMyTemplateSuggestion($input: TemplateSuggestionInput!) {
    createMyTemplateSuggestion(input: $input) {
      created { ${SUGGESTION_FIELDS} review_reason reviewed_at }
      duplicate { ${SUGGESTION_FIELDS} viewer_has_voted }
      duplicate_hidden
    }
  }
`;

export const VOTE_TEMPLATE_SUGGESTION = gql`
  mutation VoteTemplateSuggestion($id: ID!) {
    voteTemplateSuggestion(id: $id) { ${SUGGESTION_FIELDS} viewer_has_voted }
  }
`;

export const UNVOTE_TEMPLATE_SUGGESTION = gql`
  mutation UnvoteTemplateSuggestion($id: ID!) {
    unvoteTemplateSuggestion(id: $id) { ${SUGGESTION_FIELDS} viewer_has_voted }
  }
`;

export const ADMIN_TEMPLATE_SUGGESTIONS = gql`
  query AdminTemplateSuggestions($status: String, $search: String, $limit: Int, $offset: Int) {
    adminTemplateSuggestions(status: $status, search: $search, limit: $limit, offset: $offset) {
      data {
        ${SUGGESTION_FIELDS}
        review_reason
        reviewed_at
        user_id
        user_email
        user_name
        reviewed_by_id
        reviewed_by_name
      }
      total
      pageCount
    }
  }
`;

export const ADMIN_REVIEW_TEMPLATE_SUGGESTION = gql`
  mutation AdminReviewTemplateSuggestion($id: ID!, $status: String!, $reason: String, $brandKitId: ID) {
    adminReviewTemplateSuggestion(id: $id, status: $status, reason: $reason, brandKitId: $brandKitId) {
      ${SUGGESTION_FIELDS}
      review_reason
      reviewed_at
      user_id
      user_email
      user_name
      reviewed_by_id
      reviewed_by_name
    }
  }
`;
